import { Button, Form, Input, Table, message } from "antd";
import { layoutForms } from "../../../component/utility";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";
import { useEffect } from "react";

const GetListStudentComponent = (props) => {
  const [form] = Form.useForm();
  const Columns = [
    { title: "کد", dataIndex: "id", key: "id" },
    { title: "نام دانشجو", dataIndex: "name", key: "name" },
    { title: "شماره دانشجویی", dataIndex: "studentCode", key: "studentCode" },
  ];
  const _getListStudent = async () => {
    let url = Url.getStudentList;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  useEffect(() => {
    _getListStudent();
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Table
          columns={Columns}
          dataSource={props.coreData[Url.getStudentList]?.[Url.action]?.data}
          loading={props.coreData[Url.getStudentList]?.[Url.action]?.isFetching}
          rowKey={(o) => o.id}
        />
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetListStudentComponent);
